var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-group-filter"},[_c('AulaMultiselect',{attrs:{"value":_vm.value,"placeholder":_vm.$t('label.search_for_groups'),"options":_vm.groupOptions},on:{"change":_vm.emitChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }